// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Receita_AgingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/receita/aging
 *
 * Five fixed aging buckets — "0-7", "8-30", "31-60", "61-90", "90+" —
 * over the outstanding "a receber" balance on each compromisso in the
 * filter window.
 *
 * Buckets are always emitted (zero-filled if no rows fall inside) so
 * the FE can render a stable 5-cell layout without bucket lookup.
 */
import type { Receita_AgingBucketRow } from './Receita_AgingBucketRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Receita_AgingResponseDados {
buckets: Receita_AgingBucketRow[]
}

export type Receita_AgingResponse = ApiResponse<Receita_AgingResponseDados>;

registerResponseContract('Receita_AgingResponse', {
  buckets: {
    type: 'array',
    required: true,
    items: {
      bucket:       { type: 'string',  required: false },
      count:        { type: 'number',  required: false },
      valor_aberto: { type: 'number',  required: false },
    },
  },
})
